import type { FC } from "react"
import { Navigate, Outlet, useLocation } from "react-router"
import { useCurrentUser } from "@/lib/useCurrentUser"

export const LoggedOutLayout: FC = () => {
  const currentUser = useCurrentUser()
  const location = useLocation()

  if (currentUser) {
    return <Navigate to="/dashboard" replace state={{ from: location }} />
  }

  return (
    <main className="mx-auto w-full max-w-screen-md p-6">
      <Outlet />
    </main>
  )
}
